/** @format */
import home from "../src/images/home.png";
import deal from "../src/images/deal.png";
import market from "../src/images/local_market.png";

const About = () => {
  const handleClick = () => {
    const section = document.getElementById("mySection");
    section.scrollIntoView({ behavior: "smooth" });
  };

  return (<>

    <div className="about-us">
      <div className="about-us-inner">
        <div className="about-us-inner-feature">


          <div className="feature-sec">
            <img src={home} alt="home" />
            <div>
              <h2>Value Identification
              </h2>
              <p>
                Learn how to spot hidden value in properties that others overlook.

              </p>
            </div>
          </div>

          <div className="feature-sec">
            <img src={deal} alt="home" />
            <div> <h2>Deal Analysis
            </h2>
              <p>
                View our detailed calculations for determining whether a property is financially viable.

              </p></div>
          </div>
          <div className="feature-sec">
            <img src={market} alt="home" />
            <div> <h2>Local Market Insights
            </h2>
              <p>
                Get neighborhood-specific knowledge you can't find online.

              </p></div>
          </div>


        </div>


        <div className="feature-call-to-action">
          <div className="feature-call-text">
            <div>
              <h2>Ready to Attend The FREE 2 Hour Workshop?
              </h2>
              <p>Don’t miss your chance, only a few spots remain!</p>
            </div>
            <button onClick={handleClick}>Register For The Free Event </button>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default About;
